import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import FactualTopicEditor from './Editor';

export default createTaskType({
    id: 'factual_topic',
	label: 'Factual Topic',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    createItemsTemplate: () => times(8, i => ({
        is_example: i === 0,

        ...(i === 0 && { rubric_id: '' }),

        stimulus_text: i % 4 === 3 ? null : '',
        phase: `PHASE_${Math.floor(i / 4) + 1}`,

        answers: [{
            text: '',
            is_correct_answer: (i % 4) < 3,
            display_order: (i % 4) + 1,
        }],
    })),
    editor: FactualTopicEditor,

    backgroundImages: { count: 1 },

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        return task;
    },

    convertToLocalFormat(task) {
        task = cloneDeep(task);
        task.items = task.items.map((item, i) => {
            item.answers[0].is_correct_answer = (item.order % 4) < 3;
            return item;
        });
        return task;
    },

    rubric: {
        phaseCount: 2
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x?.text ?? 'N/A');
    }
});